import styled from 'styled-components'

export const SuccessBlock = styled.span`
    font-size: 12px;
    color: tomato;
    padding: 10px 0px;
    color: ${props => props.theme.color.success} !important;
    text-align: left;
    display: block;
`